import PageThumbnailsGrid from './PageThumbnailsGrid';

export default PageThumbnailsGrid;